export const CONTAINER_CONFIG = {
  baseStyle: {
    maxW: {
      md: 'container.md',
    },
  },
};
